import React, {useEffect, useState} from 'react';
import { Container, Row, Col } from 'react-bootstrap';



// // style={{width:"100%" ,height:"100%"}}

function Intro() {

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    
      useEffect(() => {
        const handleResize = () => {
          setIsSmallScreen(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

 


  return (
    <Container 
    fluid 
   className="container-section"
   
    style={{backgroundColor:"#212020",
      display: "flex",
      alignItems: "center", 
      justifyContent: "center", 
      height: isSmallScreen ? "auto" : "100vh",
      paddingTop: isSmallScreen ? "5rem" : "auto",
      paddingBottom: isSmallScreen ? "5rem" : "auto",}}>
        <Row>
            <Col xs={12} md={9} lg={9} style={{color:"white"}}>
              <h1><strong>Story</strong></h1>
              <p style={{fontSize:"0.88rem"}}>
               The "OLA" logo is inspired by the Yoruba name "Olayimika," meaning "wealth surrounds me," 
               reflecting a sense of prosperity and abundance. As a cultural enthusiast, I believe that black 
               and white designs reveal the true essence of aesthetics. The logo's black and white color scheme 
               embodies simplicity and elegance, with black symbolizing sophistication and authority, and white 
               representing purity and clarity. Together, these neutral colors create a timeless and universally 
               appealing aesthetic, highlighting the brand's commitment to understated beauty and authenticity.
                </p>
                <p style={{fontSize:"0.88rem"}}>
                This perspective aligns with the idea that black and white designs can enhance creative work 
                by focusing on the core elements without the distraction of color.
                </p>
                <p>
                </p>
            </Col>
            <Col xs={12} md={3} lg={3}></Col>
        </Row>

  </Container>
  )
}

export default Intro;
